import useDesktopChecker from "hooks/useDesktopChecker";
import "./guide-loan-officer-card.scss";
import { LoanOfficerDetail } from "pages/application/applicationService";

interface GuideLoanOfficerCardProps {
  readonly loInfo?: LoanOfficerDetail;
  readonly onClose?: () => void;
  readonly firstName?: string;
}

export default function GuideLoanOfficerCard({ loInfo, onClose, firstName }: GuideLoanOfficerCardProps) {
  const isDesktop = useDesktopChecker();
  const phoneNumber = loInfo?.phones[0]?.number;

  return (
    <div className="guide-lo-card__container">
      <button className="guide-lo-card__close" onClick={onClose} aria-label="Close">
        &#10005;
      </button>
      <div className="guide-lo-card__wrapper">
        <div className="guide-lo-card__content paragraph-medium-semibold">
          Hi {firstName} 
        </div>
        <div className="guide-lo-card__description paragraph-medium-regular">
           Want to talk about your loan options?
        </div>
        {!isDesktop && (
          <a className="guide-lo-card__call-link label-large-medium" href={`tel:${phoneNumber ?? ''}`}>
            Call Now
          </a>
        )}
      </div>
    </div>
  );
}
